import { useEffect } from "react";
import type { FieldErrors } from "react-hook-form";
import { voucherCodeErrorEvent, voucherCodeStartEvent } from "../../tracking/events";
import type { FormValues } from "./index";

export const useGtmEvents = (errors: FieldErrors<FormValues>, apiError?: string, _authorizationMethod?: string) => {
  useEffect(() => {
    const isErrorMessage = Object.keys(errors).length > 0 || apiError;

    if (isErrorMessage) {
      const errorType = apiError || Object.keys(errors).join(", ");
      voucherCodeErrorEvent({ errorType });
    }
  }, [errors, apiError]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length === 1) {
      voucherCodeStartEvent();
    }
  };

  return { handleInputChange };
};
